


export class MB51 {
  "plant";
  "userName";
  "purchaseOrder";
  "entryDate";
  "customer";
  "postingDate";
  "materialDocument";
  "material";
  "quantity";
  "amountInLc";
  "reference";
  "storageLocation";
  "timeOfEntry";
  "movementType";
  "salesOrder";
  "network";
  "meterialDescription";
  "name1";
  "movementTypeText";
  "specialStock";
  "billOfLading";
  "materialDocItem";
  "documentHeaderText";
  "qtyInUnOfEntry";
  "unitOfEntry";
  "asset";
  "order";
  "subnumber";
  "counter";
  "vendor";
  "operationActivity";
  "routingNumberOfOperations";
  "wbsElement";
  "documentDate";
  "item";
  "qtyInOpUn";
  "orderPriceUnit";
  "orderUnit";
  "qtyInOrderUnit";
  "companyCode";
  "valuationType";
  "batch";
  "smartNumber";
  "extAmountInLocalCurrency";
  "salesValue";
  "reasonForMovement";
  "salesOrderSchedule";
  "salesOrderItem";
  "costCenter";
  "movementIndicator";
  "consumption";
  "receiptIndicator";
  "salesOrder2";
  "salesOrderItem2";
  "baseUnitOfMeasure";
  "materialDocYear";
  "wbsElement2";
  "reservation";
  "itemNoStockTransferReserv";
  "debitCreditInd";
  "transEventType";
  "salesValueIncVat";
  "currency";
  "goodsReceiptIssueSlip";
  "itemAutomaticallyCreated";
  "originalLineItem";
  "multipleAccountAssignment";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MB51`.
   */
  static getModelName() {
    return "MB51";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MB51 for dynamic purposes.
  **/
  static factory(data) {
    return new MB51(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'MB51',
      plural: 'MB51s',
      path: 'MB51s',
      properties: {
        "plant": {
          name: 'plant',
          type: 'string'
        },
        "userName": {
          name: 'userName',
          type: 'string'
        },
        "purchaseOrder": {
          name: 'purchaseOrder',
          type: 'string'
        },
        "entryDate": {
          name: 'entryDate',
          type: 'string'
        },
        "customer": {
          name: 'customer',
          type: 'string'
        },
        "postingDate": {
          name: 'postingDate',
          type: 'string'
        },
        "materialDocument": {
          name: 'materialDocument',
          type: 'string'
        },
        "material": {
          name: 'material',
          type: 'string'
        },
        "quantity": {
          name: 'quantity',
          type: 'string'
        },
        "amountInLc": {
          name: 'amountInLc',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "storageLocation": {
          name: 'storageLocation',
          type: 'string'
        },
        "timeOfEntry": {
          name: 'timeOfEntry',
          type: 'string'
        },
        "movementType": {
          name: 'movementType',
          type: 'string'
        },
        "salesOrder": {
          name: 'salesOrder',
          type: 'string'
        },
        "network": {
          name: 'network',
          type: 'string'
        },
        "meterialDescription": {
          name: 'meterialDescription',
          type: 'string'
        },
        "name1": {
          name: 'name1',
          type: 'string'
        },
        "movementTypeText": {
          name: 'movementTypeText',
          type: 'string'
        },
        "specialStock": {
          name: 'specialStock',
          type: 'string'
        },
        "billOfLading": {
          name: 'billOfLading',
          type: 'string'
        },
        "materialDocItem": {
          name: 'materialDocItem',
          type: 'string'
        },
        "documentHeaderText": {
          name: 'documentHeaderText',
          type: 'string'
        },
        "qtyInUnOfEntry": {
          name: 'qtyInUnOfEntry',
          type: 'string'
        },
        "unitOfEntry": {
          name: 'unitOfEntry',
          type: 'string'
        },
        "asset": {
          name: 'asset',
          type: 'string'
        },
        "order": {
          name: 'order',
          type: 'string'
        },
        "subnumber": {
          name: 'subnumber',
          type: 'string'
        },
        "counter": {
          name: 'counter',
          type: 'string'
        },
        "vendor": {
          name: 'vendor',
          type: 'string'
        },
        "operationActivity": {
          name: 'operationActivity',
          type: 'string'
        },
        "routingNumberOfOperations": {
          name: 'routingNumberOfOperations',
          type: 'string'
        },
        "wbsElement": {
          name: 'wbsElement',
          type: 'string'
        },
        "documentDate": {
          name: 'documentDate',
          type: 'string'
        },
        "item": {
          name: 'item',
          type: 'string'
        },
        "qtyInOpUn": {
          name: 'qtyInOpUn',
          type: 'string'
        },
        "orderPriceUnit": {
          name: 'orderPriceUnit',
          type: 'string'
        },
        "orderUnit": {
          name: 'orderUnit',
          type: 'string'
        },
        "qtyInOrderUnit": {
          name: 'qtyInOrderUnit',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "valuationType": {
          name: 'valuationType',
          type: 'string'
        },
        "batch": {
          name: 'batch',
          type: 'string'
        },
        "smartNumber": {
          name: 'smartNumber',
          type: 'string'
        },
        "extAmountInLocalCurrency": {
          name: 'extAmountInLocalCurrency',
          type: 'string'
        },
        "salesValue": {
          name: 'salesValue',
          type: 'string'
        },
        "reasonForMovement": {
          name: 'reasonForMovement',
          type: 'string'
        },
        "salesOrderSchedule": {
          name: 'salesOrderSchedule',
          type: 'string'
        },
        "salesOrderItem": {
          name: 'salesOrderItem',
          type: 'string'
        },
        "costCenter": {
          name: 'costCenter',
          type: 'string'
        },
        "movementIndicator": {
          name: 'movementIndicator',
          type: 'string'
        },
        "consumption": {
          name: 'consumption',
          type: 'string'
        },
        "receiptIndicator": {
          name: 'receiptIndicator',
          type: 'string'
        },
        "salesOrder2": {
          name: 'salesOrder2',
          type: 'string'
        },
        "salesOrderItem2": {
          name: 'salesOrderItem2',
          type: 'string'
        },
        "baseUnitOfMeasure": {
          name: 'baseUnitOfMeasure',
          type: 'string'
        },
        "materialDocYear": {
          name: 'materialDocYear',
          type: 'string'
        },
        "wbsElement2": {
          name: 'wbsElement2',
          type: 'string'
        },
        "reservation": {
          name: 'reservation',
          type: 'string'
        },
        "itemNoStockTransferReserv": {
          name: 'itemNoStockTransferReserv',
          type: 'string'
        },
        "debitCreditInd": {
          name: 'debitCreditInd',
          type: 'string'
        },
        "transEventType": {
          name: 'transEventType',
          type: 'string'
        },
        "salesValueIncVat": {
          name: 'salesValueIncVat',
          type: 'string'
        },
        "currency": {
          name: 'currency',
          type: 'string'
        },
        "goodsReceiptIssueSlip": {
          name: 'goodsReceiptIssueSlip',
          type: 'string'
        },
        "itemAutomaticallyCreated": {
          name: 'itemAutomaticallyCreated',
          type: 'string'
        },
        "originalLineItem": {
          name: 'originalLineItem',
          type: 'string'
        },
        "multipleAccountAssignment": {
          name: 'multipleAccountAssignment',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/MB51.js